import styled from 'styled-components'
import { ReactComponent as HighlighterIcon } from 'assets/icons/highlighter.svg'
import { ReactComponent as CalculatorIcon } from 'assets/icons/calculator.svg'
import { ReactComponent as ContrastIcon } from 'assets/icons/contrast.svg'
import { ReactComponent as NotesIcon } from 'assets/icons/notes.svg'
import { ReactComponent as RedMarkerDot } from 'assets/icons/red-color-marker.svg'
import { ReactComponent as BlackMarkerDot } from 'assets/icons/black-color-marker.svg'
import { ReactComponent as EraserIcon } from 'assets/icons/eraser.svg'
import { ReactComponent as RemoveIcon } from 'assets/img/remove-icon-bold.svg'
import RaisedButton from 'components/RaisedButton/RaisedButton'

export const FooterIconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 15px;
  gap: 15px;
`

export const FooterHighlighterIcon = styled(HighlighterIcon)<{
  $disabled?: boolean
}>`
  opacity: ${(props) => (props.$disabled ? 0.5 : 1)};
`

export const FooterCalculatorIcon = styled(CalculatorIcon)<{
  $disabled?: boolean
}>`
  opacity: ${(props) => (props.$disabled ? 0.5 : 1)};
`

export const FooterContrastIcon = styled(ContrastIcon)<{ $disabled?: boolean }>`
  opacity: ${(props) => (props.$disabled ? 0.5 : 1)};
`

export const FooterNotesIcon = styled(NotesIcon)<{ $disabled?: boolean }>`
  opacity: ${(props) => (props.$disabled ? 0.5 : 1)};
`

export const NotesTrigger = styled.button<{ $disabled?: boolean }>`
  border: none;
  background: transparent;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: ${(props) => (props.$disabled ? 'default' : 'pointer')};
  pointer-events: ${(props) => (props.$disabled ? 'none' : 'auto')};

  &:focus-visible {
    outline: 2px solid ${(props) => props.theme.colors.border.primary};
    outline-offset: 2px;
    border-radius: 6px;
  }
`

export const MarkerPopupWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
`

export const HighlighterPopupWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
`

export const ContrastPopupWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  z-index: 25;
`

export const CalculatorPopupWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
`

export const MarkerTrigger = styled.div<{ $disabled?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  cursor: ${(props) => (props.$disabled ? 'default' : 'pointer')};
  opacity: ${(props) => (props.$disabled ? 0.5 : 1)};
  pointer-events: ${(props) => (props.$disabled ? 'none' : 'auto')};

  &:focus-visible {
    outline: ${(props) => `2px solid ${props.theme.colors.border.primary}`};
    outline-offset: 2px;
    border-radius: 6px;
  }
`

export const ContrastTrigger = styled.button<{ $disabled?: boolean }>`
  border: none;
  background: transparent;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  cursor: ${(props) => (props.$disabled ? 'default' : 'pointer')};
  opacity: ${(props) => (props.$disabled ? 0.5 : 1)};
  pointer-events: ${(props) => (props.$disabled ? 'none' : 'auto')};

  &:focus-visible {
    outline: ${(props) => `2px solid ${props.theme.colors.border.primary}`};
    outline-offset: 2px;
    border-radius: 6px;
  }
`

export const CalculatorTrigger = styled.button<{ $disabled?: boolean }>`
  border: none;
  background: transparent;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  cursor: ${(props) => (props.$disabled ? 'default' : 'pointer')};
  opacity: ${(props) => (props.$disabled ? 0.5 : 1)};
  pointer-events: ${(props) => (props.$disabled ? 'none' : 'auto')};

  &:focus-visible {
    outline: ${(props) => `2px solid ${props.theme.colors.border.primary}`};
    outline-offset: 2px;
    border-radius: 6px;
  }
`

export const CalculatorPopupContainer = styled.div`
  position: absolute;
  bottom: 60px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 200px;
  border-radius: 8px;
  border: ${(props) => `1px solid ${props.theme.colors.border.primary}`};
  background: ${(props) => props.theme.colors.card.background};
  box-sizing: border-box;
  padding: 12px;
  z-index: 120;
`

export const CalculatorOptionButton = styled.button`
  width: 100%;
  min-height: 40px;
  border: 1px solid ${(props) => props.theme.colors.border.primary};
  border-radius: 8px;
  background: ${(props) => props.theme.colors.card.surface};
  color: ${(props) => props.theme.colors.text.primary};
  font-family: ${(props) => props.theme.typography.fontNunitoSans};
  font-size: 14px;
  font-weight: 700;
  padding: 8px 12px;
  cursor: pointer;

  &:focus-visible {
    outline: ${(props) => `2px solid ${props.theme.colors.border.primary}`};
    outline-offset: 2px;
  }
`

export const MarkerPopupContainer = styled.div`
  position: absolute;
  bottom: 60px;
  left: 75px;
  transform: translateX(-50%);
  display: flex;
  width: 240px;
  height: 45px;
  gap: 15px;
  border-radius: 8px;
  border: ${(props) => `1px solid ${props.theme.colors.border.primary}`};
  background: ${(props) => props.theme.colors.card.background};
  box-sizing: border-box;
  align-items: center;
  justify-content: center;
  z-index: 120;
`

export const HighlighterPopupContainer = styled.div`
  position: absolute;
  bottom: 60px;
  left: 95px;
  transform: translateX(-50%);
  display: flex;
  width: 200px;
  height: 45px;
  gap: 15px;
  border-radius: 8px;
  border: ${(props) => `1px solid ${props.theme.colors.border.primary}`};
  background: ${(props) => props.theme.colors.card.background};
  box-sizing: border-box;
  align-items: center;
  justify-content: center;
  z-index: 120;
`
export const ContrastPopupContainer = styled.div`
  position: absolute;
  left: -5px;
  bottom: 60px;
  border-radius: 8px;
  border: ${(props) => `1px solid ${props.theme.colors.border.primary}`};
  background: ${(props) => props.theme.colors.card.background};
  box-sizing: border-box;
  padding: 11px;
  z-index: 30;
`

export const ContrastCardGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(5, 150px);
  gap: 12px;

  @media (max-width: 1024px) {
    grid-template-columns: repeat(3, 150px);
  }

  @media (max-width: 680px) {
    grid-template-columns: repeat(2, 150px);
  }
`

export const ContrastCard = styled.span<{ $isSelected?: boolean }>`
  width: 150px;
  height: 65px;
  border-radius: 8px;
  border: 1px solid ${(props) => props.theme.colors.border.primary};
  text-align: left;
  font-family: ${(props) => props.theme.typography.fontNunitoSans};
  font-size: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 400;
  line-height: 22px;
  padding: 14px 20px 14px 14px;
  cursor: pointer;

  /**
   * Keep the active contrast preset visibly distinct from the other options
   * without changing the preset-specific foreground or background colors.
   */
  outline: ${(props) =>
    props.$isSelected
      ? `1px solid ${props.theme.colors.text.primary}`
      : 'none'};
  outline-offset: 2px;

  &:focus-visible {
    outline: ${(props) => `2px solid ${props.theme.colors.border.primary}`};
    outline-offset: 2px;
  }
`

export const ClearAllButton = styled(RaisedButton)`
  font-size: 12px;
  color: ${(props) => props.theme.colors.text.primary};
  font-family: ${(props) => props.theme.typography.fontNunito};
  height: 19px;
  font-weight: 400;
  justify-content: center;
  width: 56px;
`

export const PopupRedDotIcon = styled(RedMarkerDot)<{
  $disabled?: boolean
  $isFaded?: boolean
}>`
  cursor: ${(props) => (props.$disabled ? 'default' : 'pointer')};
  opacity: ${(props) => (props.$disabled || props.$isFaded ? 0.5 : 1)};
  pointer-events: ${(props) => (props.$disabled ? 'none' : 'auto')};

  &:focus-visible {
    outline: ${(props) => `2px solid ${props.theme.colors.border.primary}`};
    outline-offset: 2px;
    border-radius: 6px;
  }
`

export const PopupBlackDotIcon = styled(BlackMarkerDot)<{
  $disabled?: boolean
  $isFaded?: boolean
}>`
  cursor: ${(props) => (props.$disabled ? 'default' : 'pointer')};
  opacity: ${(props) => (props.$disabled || props.$isFaded ? 0.5 : 1)};
  pointer-events: ${(props) => (props.$disabled ? 'none' : 'auto')};

  &:focus-visible {
    outline: ${(props) => `2px solid ${props.theme.colors.border.primary}`};
    outline-offset: 2px;
    border-radius: 6px;
  }
`

export const PopupEraserIcon = styled(EraserIcon)<{ $disabled?: boolean }>`
  cursor: ${(props) => (props.$disabled ? 'default' : 'pointer')};
  opacity: ${(props) => (props.$disabled ? 0.5 : 1)};
  pointer-events: ${(props) => (props.$disabled ? 'none' : 'auto')};

  &:focus-visible {
    outline: ${(props) => `2px solid ${props.theme.colors.border.primary}`};
    outline-offset: 2px;
    border-radius: 6px;
  }
`

export const PopupHighlighterIcon = styled(HighlighterIcon)<{
  $disabled?: boolean
  $isFaded?: boolean
}>`
  cursor: ${(props) => (props.$disabled ? 'default' : 'pointer')};
  opacity: ${(props) => (props.$disabled || props.$isFaded ? 0.5 : 1)};
  pointer-events: ${(props) => (props.$disabled ? 'none' : 'auto')};

  &:focus-visible {
    outline: ${(props) => `2px solid ${props.theme.colors.border.primary}`};
    outline-offset: 2px;
    border-radius: 6px;
  }
`

export const PopupRemoveIcon = styled(RemoveIcon)<{ $disabled?: boolean }>`
  width: 19px;
  height: 19px;
  cursor: ${(props) => (props.$disabled ? 'default' : 'pointer')};
  opacity: ${(props) => (props.$disabled ? 0.5 : 1)};
  pointer-events: ${(props) => (props.$disabled ? 'none' : 'auto')};

  &:focus-visible {
    outline: ${(props) => `2px solid ${props.theme.colors.border.primary}`};
    outline-offset: 2px;
    border-radius: 6px;
  }
`
